export const update = {
  updateSuccessfully: 'タンクを正常に更新しました！',
}
